import makeStyles from '@mui/styles/makeStyles'

const getBorderRadius = ({ smallMedia, isDirect, down1300, viewing }) => {
  if (smallMedia) {
    return '0'
  }

  if (isDirect) {
    return '1rem'
  }

  if (down1300 && !viewing) {
    return '0 0 1rem 1rem'
  }

  return '0 1rem 1rem 0'
}

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 20,
    display: 'flex',
    flexDirection: 'column',
    height: ({ isConsentVisible, isKeyboardOpen }) =>
      isConsentVisible
        ? 'calc(100svh - 80px - 1rem - 52px)'
        : isKeyboardOpen
        ? '100svh'
        : 'calc(100svh - 80px - 1rem)',
    borderRadius: getBorderRadius,
    boxSizing: 'border-box',
    backgroundColor: 'white',
    boxShadow: 'rgba(66, 81, 89, 0.05) 0px 4px 6px 0px'
  },

  centeredRoot: {
    flexGrow: 1,
    marginLeft: 'auto',
    marginRight: 'auto',
    maxWidth: '1000px'
  },

  contentArea: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    position: 'relative'
  },

  chat: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    backgroundColor: '#F7F8F9',
    height: '0'
  },

  typing: {
    position: 'sticky',
    bottom: '0',
    padding: '0 0.5rem 0rem 0.5rem',
    fontSize: theme.size.xs,
    backgroundColor: '#F7F8F9'
  },

  typingFull: {
    width: 'calc(100% - 3rem)',
    margin: '0 auto',
    backgroundColor: 'white'
  },

  banner: {
    backgroundColor: '#e7ebed',
    zIndex: 100
  },

  fabRoot: {
    position: 'absolute',
    cursor: 'pointer',
    right: 24,
    bottom: 132,
    zIndex: 100,
    [theme.breakpoints.down('sm')]: {
      right: 8,
      bottom: 86
    }
  }
}))

export default useStyles
